export default {
  title: '{{company}} päivitti noutoaikasi',
  title_on_site: '{{company}} päivitti, milloin tilauksesi tarjoillaan',
  new_time_label: 'Uusi aika',
};
